import type { Customer } from '@eliadmin/core/src/api/customers/customers-types';
import { Button } from '@eliadmin/core/src/components/ui/button';
import {
  ResponsiveDialog,
  ResponsiveDialogContent,
  ResponsiveDialogFooter,
  ResponsiveDialogHeader,
  ResponsiveDialogTitle,
} from '@eliadmin/core/src/components/ui/responsive-dialog';
import { toast } from '@eliadmin/core/src/components/ui/use-toast';
import { useTranslations } from '@eliadmin/core/src/hooks/use-translations';
import { initCustomerStore, useCustomerStore } from '@eliadmin/core/src/stores/customer-store';

export const CancelSubscriptionModal = ({
  isOpen,
  setIsOpen,
}: {
  isOpen: boolean;
  setIsOpen: (isOpen: boolean) => void;
}) => {
  const { t } = useTranslations();
  const me = useCustomerStore(s => s.me);

  return (
    <ResponsiveDialog open={isOpen} onOpenChange={setIsOpen}>
      <ResponsiveDialogContent>
        <ResponsiveDialogHeader>
          <ResponsiveDialogTitle hidden>{t('text3223')}</ResponsiveDialogTitle>
          <h2 className="text-lg font-semibold">{t('text3223')}</h2>
        </ResponsiveDialogHeader>
        {t('text3224')}
        <ResponsiveDialogFooter className="flex flex-col-reverse md:flex-row">
          <Button type="button" variant="destructive" onClick={() => setIsOpen(false)}>
            {t('text272')}
          </Button>
          <Button
            type="button"
            asChild
            onClick={() => {
              initCustomerStore({
                authToken: me?.authToken || '',
                customer: { ...me?.customer, newsletter_subscribed: false } as Customer,
              });
              toast({
                title: t('text3225'),
                variant: 'success',
              });
              setIsOpen(false);
            }}
          >
            <a
              href={me?.customer.newsletter_unsubscribe_url}
              target="_blank"
              rel="noopener noreferrer"
            >
              {t('text3223')}
            </a>
          </Button>
        </ResponsiveDialogFooter>
      </ResponsiveDialogContent>
    </ResponsiveDialog>
  );
};
